function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m43.332 26.668h-33.332v6.668h13.332v39.996h6.668v-39.996h13.332z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90 23.336v-6.668c-4.0039 0-7.5547 1.8047-10 4.6016-2.4453-2.7969-5.9961-4.6016-10-4.6016v6.668c3.6836 0 6.668 2.9844 6.668 6.6641v40c0 3.6797-2.9844 6.6641-6.668 6.6641v6.6641c4.0039 0 7.5547-1.8047 10-4.5977 2.4453 2.793 5.9961 4.5977 10 4.5977v-6.6641c-3.6836 0-6.668-2.9805-6.668-6.6641v-40c0-3.6797 2.9844-6.6641 6.668-6.6641z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m62.355 65.688c-0.60547 0.60547-1.4375 0.97656-2.3555 0.97656-1.8398 0-3.332-1.4883-3.332-3.3359v-13.328h6.6641v-6.6641h-6.6641v-10h-6.668v10h-6.668v6.6641h6.668v13.332c0 5.5195 4.4805 10 10 10 2.7617 0 5.2617-1.1172 7.0703-2.9297z"
}));

var SvgEditor = function SvgEditor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editor.b902ba61.svg";
export { ForwardRef as ReactComponent };